/**
 * App config
 */
export default defineAppConfig({
    maxNumberOfPeople: 20,
}) satisfies AppConfig;
